import React, { FC, memo } from 'react';
import { ICalendarForFilter, PageRoutes, ProfileRoutes } from '@utils';
import { Link } from 'react-router-dom';
import { IColor } from 'src/utils/types/colors';
import { Checkbox } from '../../checkbox';
import { CollapsibleList } from '../../collapsibleList';
import { Plus } from '../../svgs';
import { LoadableWrapper } from '../../loader';
import '../../../styles/components/privateCalendars.scss';

interface IPrivateCalendarsProps {
  isLoading: boolean;
  calendars: ICalendarForFilter[];
  getHexCodefromColorName: (colorName: string) => IColor;
  onCheckedCalendar: (calendar: ICalendarForFilter) => void;
}

export const PrivateCalendars: FC<IPrivateCalendarsProps> = memo(({ 
  calendars, isLoading, onCheckedCalendar, getHexCodefromColorName 
}) => {
  return (
    <LoadableWrapper loading={isLoading}>
      <div className='block'>
        <CollapsibleList<ICalendarForFilter>
          title='Мои календари'
          listItems={calendars}
          placeholder={'Календарей нет'}
          icon={
            <Link to={`${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.CONNECTED_CALENDARS_TAB}`} className='icon-plus'>
              <Plus />
            </Link>
          }
          renderOption={(calendar) => (
            <div className='private-calendar' key={calendar.calendarUri}>
              <Checkbox
                label={calendar.title}
                value={calendar.isSelected}
                color={getHexCodefromColorName(calendar.calendarColor).hexCode}
                onChange={() => onCheckedCalendar(calendar)}
              />
            </div>
          )}
        />
      </div>
    </LoadableWrapper>
  );
});
